import WorkspaceItem from './WorkspaceItem';

export default WorkspaceItem;
